"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var GlobalSize = /*#__PURE__*/function (GlobalSize) {
  GlobalSize["SMALL"] = "small";
  GlobalSize["MEDIUM"] = "medium";
  GlobalSize["LARGE"] = "large";
  GlobalSize["EXTRA_LARGE"] = "extraLarge";
  GlobalSize["XLARGE"] = "xlarge";
  return GlobalSize;
}(GlobalSize || {});
var _default = exports["default"] = GlobalSize;